import React from "react";

/**
 * SectionLabel — small uppercase muted label used as a section heading inside tabs.
 */
const SectionLabel = ({ children }) => (
  <p
    style={{
      fontSize: 11,
      fontWeight: 500,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: "#adb5bd",
      margin: "0 0 12px",
    }}
  >
    {children}
  </p>
);

export default SectionLabel;
